module.exports = __webpack_public_path__ + "static/the-fountainhead-46baec882d5a1c95460f3cf20224032f.jpg";